import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const setup = () => {
  const triggers = document.querySelectorAll('[data-w-section-header]');

  let mediaManager = gsap.matchMedia();
  mediaManager.add(
    {
      isMobile: `(max-width: 768px), (min-width: 768px) and (max-width: 1366px) and (orientation: portrait)`,
      isDesktop: `(min-width: 768px) and (max-width: 1366px) and (orientation: landscape), (min-width: 1366px)`,
    },
    (context) => {
      let { isDesktop, isMobile } = context.conditions;

      if (isDesktop) {
        triggers.forEach((trigger) => {
          gsap.to(trigger, {
            scrollTrigger: {
              trigger: trigger,
              start: 'top bottom',
              end: 'bottom top',
              scrub: true,
              onUpdate: (self) => {
                trigger.style.setProperty('--_progress', -0.5 + self.progress);
              },
            },
          });
        });
      }
    }
  );
};

export default function SectionHeader() {
  return {
    init: () => {
      setup();
    },
  };
}
